import React, { useState } from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

import UnAuthedLayout from "../../component/UnAuthedLayout";
import PrimaryTextField from "../../component/PrimaryTextField";
import PrimaryButton from "../../component/PrimaryButton";
import PrimaryLink from "../../component/PrimaryLink";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/thunk/userThunk";
import { useNavigate } from "react-router-dom";
import { palette } from "../../themes/theme";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // API call for resetting password
  // const resetPasswordApiCall = async (email) => {
  //   try {
  //     const response = await axios.post("/api/auth/forgot-password", { email });
  //     console.log("Reset password link sent:", response.data);
  //     alert("Reset password link has been sent to your email.");
  //   } catch (error) {
  //     console.error(
  //       "Failed to send reset link:",
  //       error.response?.data || error.message
  //     );
  //     alert("Failed to send reset link. Please try again.");
  //   }
  // };
  const handleResetPasswordClick = async (email) => {
    setLoading(true);
    try {
      await dispatch(forgotPassword({ email })).unwrap();
      navigate("sign-in");
    } catch (error) {
      console.log("Failed to send reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Formik for form state management and validation
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      handleResetPasswordClick(values.email);
      // resetPasswordApiCall(values.email); // Call the API with the email
    },
  });

  return (
    <UnAuthedLayout showLoader={false}>
      <Typography variant="h5" gutterBottom color={palette.text.dark} fontWeight="bolder">
        Forgot your password?
      </Typography>
      <Typography color={palette.text.dark}>
        Enter your email below. We will then send a reset-password link to your
        email address.
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <PrimaryTextField
          label="Email Address"
          type="email"
          fullWidth
          margin="normal"
          variant="outlined"
          id="email"
          name="email"
          required
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          sx={{ mt: "16px", fontWeight: "bold", color: palette.text.white }}
          loading={loading}
        >
          Reset Password
        </Button>
      </form>
      <CustomLinkContainer>
        <PrimaryLink to="/sign-in">Go back to login page</PrimaryLink>
      </CustomLinkContainer>
    </UnAuthedLayout>
  );
};

const CustomLinkContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",
}));

export default ForgotPassword;
